<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec exposures-segs-sec info-popups">
      <div class="container-fluid">
        <div class="row segs-particle-risk-row">
          <div class="col-md-12 col-lg-12 border-right border-top">
            <div class="card-inner-main-div">
              <ng-container>
                <div class="white-box">
                  <div class="row">
                    <div class="col-lg-12 map-container">
                      <app-maplibre-realtime-map #realtimeMap [nodes]="nodes" [heatmapData]="heatmapData"
                        [heatmapImage]="heatmapImage" [showHeatmap]="showHeatmap"
                        [loading]="loading" (openNodeDetails)="openNodeDetails($event)"
                      (toggleHeatmapEmit)="toggleHeatmap($event)" [selectedNode]="selectedNode"></app-maplibre-realtime-map>
                      @if (noDataFound) {
                        <div class="no-data-overlay">
                          <span>{{ 'No nodes found' | translate }}</span>
                        </div>
                      }
                    </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row location-or-plan-row">
      </div>
    </div>
  </section>
</app-sidebar-layout>
</div>

<app-flyout-container #flyout></app-flyout-container>
